import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Nav } from "./Nav";
import { TopBar } from "./TopBar";
import { Ambient, BrandLoader, BrandMark } from "./Ambient";
import { ChangePasswordForm } from "@/components/auth/ChangePasswordForm";

const ForceChange = ({ user, logout }) => (
  <div className="relative min-h-screen grid place-items-center p-6">
    <Ambient />
    <div className="relative z-10 w-full max-w-md rounded-2xl glass border glow-border p-8 fade-up" data-testid="force-password-change">
      <BrandMark size="w-12 h-12" />
      <h2 className="mt-4 text-2xl font-bold text-slate-900 dark:!text-white">Choose your own password</h2>
      <p className="mt-1 mb-5 text-sm text-slate-600 dark:!text-slate-300">Welcome, {user.name}. Enter the temporary password you were given, then choose a new one.</p>
      <ChangePasswordForm />
      <button onClick={logout} className="mt-4 text-xs underline text-slate-500" data-testid="force-change-logout">Sign out</button>
    </div>
  </div>
);

export const ProtectedLayout = () => {
  const { user, meta, loading, logout } = useAuth();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(localStorage.getItem("nav-collapsed") === "1");
  if (loading || (user && !meta)) return <><Ambient /><BrandLoader /></>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForceChange user={user} logout={logout} />;
  const flip = () => { localStorage.setItem("nav-collapsed", collapsed ? "0" : "1"); setCollapsed(!collapsed); };
  return (
    <div className="min-h-screen flex">
      <Ambient />
      <Nav open={open} onClose={() => setOpen(false)} collapsed={collapsed} onCollapse={flip} />
      <div className={`relative z-10 flex-1 min-w-0 transition-[padding] duration-300 print:pl-0 ${collapsed ? "lg:pl-[84px]" : "lg:pl-[272px]"}`}>
        <TopBar onMenu={() => setOpen(true)} />
        <main className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8 print:p-0 print:max-w-none">
          <div key={loc.pathname} className="page-enter"><Outlet /></div>
        </main>
      </div>
    </div>
  );
};
